/**
 * Cottolio Product FAQ — smooth accordion open/close.
 * Matches features-accordion-cottolio height animation pattern.
 */
(function () {
  const SECTION_SELECTOR = '.product-faq-cottolio';

  function closePanel(panel, toggle) {
    if (!panel || !panel.classList.contains('is-open')) return;

    panel.classList.remove('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');

    const onEnd = function (event) {
      if (event.target !== panel || event.propertyName !== 'grid-template-rows') return;
      panel.removeEventListener('transitionend', onEnd);
      if (!panel.classList.contains('is-open')) panel.hidden = true;
    };

    panel.addEventListener('transitionend', onEnd);
  }

  function openPanel(panel, toggle) {
    if (!panel) return;

    panel.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        panel.classList.add('is-open');
      });
    });

    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }

  function bindItem(item) {
    const toggle = item.querySelector('.product-faq-cottolio__summary');
    const panel = item.querySelector('.product-faq-cottolio__panel');
    if (!toggle || !panel || toggle.dataset.faqBound === 'true') return;

    toggle.dataset.faqBound = 'true';

    toggle.addEventListener('click', function () {
      const isOpen = item.classList.contains('is-open');

      if (isOpen) {
        item.classList.remove('is-open');
        closePanel(panel, toggle);
      } else {
        item.classList.add('is-open');
        openPanel(panel, toggle);
      }
    });
  }

  function initSection(section) {
    if (!section || section.dataset.productFaqInit === 'true') return;
    section.dataset.productFaqInit = 'true';
    section.querySelectorAll('.product-faq-cottolio__item').forEach(bindItem);
  }

  function initAll(root) {
    const sections = root
      ? root.matches?.(SECTION_SELECTOR)
        ? [root]
        : root.querySelectorAll(SECTION_SELECTOR)
      : document.querySelectorAll(SECTION_SELECTOR);

    sections.forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
